import { render, staticRenderFns } from "./DevicesNew.vue?vue&type=template&id=74c710e8"
import script from "./DevicesNew.vue?vue&type=script&lang=js"
export * from "./DevicesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports